import { api } from "./api";
import { createImageThumbnail } from "./imageUpload";

export type BackfillMediaRecord = {
  id: string;
  fileKey: string;
  category: string;
  filename: string | null;
  mimeType: string | null;
  fileSize: number | null;
  relatedType: string | null;
  relatedId: string | null;
  createdAt: string;
};

let backfillRunning = false;

function mediaUrl(fileKey: string): string {
  return `/api/app/media/${encodeURIComponent(fileKey)}`;
}

export async function backfillMediaThumbnails(
  media: BackfillMediaRecord[],
  onCreated: (item: BackfillMediaRecord) => void,
): Promise<void> {
  if (backfillRunning) return;
  const thumbnailTargets = new Set(
    media
      .filter((item) => item.relatedType === "media-thumbnail" && item.relatedId)
      .map((item) => String(item.relatedId)),
  );
  const missing = media
    .filter((item) => item.relatedType !== "media-thumbnail" && !thumbnailTargets.has(item.fileKey))
    .slice(0, 4);
  if (missing.length === 0) return;

  backfillRunning = true;
  try {
    // 一覧の初期画像表示を優先し、既存写真の変換は少し遅らせて開始する。
    await new Promise<void>((resolve) => window.setTimeout(resolve, 2_500));
    for (const item of missing) {
      try {
        const response = await fetch(mediaUrl(item.fileKey), {
          credentials: "same-origin",
        });
        if (!response.ok) continue;
        const blob = await response.blob();
        const type = blob.type || item.mimeType || "image/jpeg";
        if (!type.startsWith("image/")) continue;
        const source = new File([blob], item.filename || "existing-photo", {
          type,
          lastModified: Date.now(),
        });
        const thumbnail = await createImageThumbnail(source);
        if (!thumbnail) continue;

        const form = new FormData();
        form.set("file", thumbnail);
        form.set("filename", thumbnail.name);
        form.set("category", item.category);
        form.set("relatedType", "media-thumbnail");
        form.set("relatedId", item.fileKey);
        const result = await api<{ ok: true; media: BackfillMediaRecord }>("/api/app/media", {
          method: "POST",
          headers: { "x-silent-media-error": "1" },
          body: form,
        });
        onCreated(result.media);
        navigator.serviceWorker?.controller?.postMessage({
          type: "media-map-refresh",
          fileKey: item.fileKey,
        });
      } catch (error) {
        console.warn("thumbnail-backfill-failed", item.fileKey, error);
      }
    }
  } finally {
    backfillRunning = false;
  }
}
